import _ from 'lodash';
import { AbstractControl, Validators } from '@angular/forms';
import * as moment from 'moment';

import { CampaignSchema } from './campaign';
import { requiredFalse } from '../validators/requiredFalse.validator';
import { AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';

export const PartySignUpFormSchema = {
    'fields': [{
        'field': 'id',
        'value': '',
        'validators': []
    },{
        'field': 'name',
        'type': 'string',
        'value': '',
        'options': {
            'validators': (data) => {
                const status = data.hasOwnProperty("status") ? data.status: 0;
                return status == 0 ? [Validators.required, Validators.maxLength(128)]: [];
            }
        }
    }, {
        'field': 'desc',
        'type': 'string',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'options',
        'type': 'array',
        'value': [],
        'options': {
            'validators': (data) => {
                return data.type === 2 ? [Validators.required, Validators.minLength(1)]: [];
            }
        }
    }, {
        'field': 'type',
        'type': 'number',
        'value': '',
        'validators': [Validators.required],
        'options': {
            'setter': (data, value) => value ? value: ""
        }
    }, {
        'field': 'required',
        'type': 'boolean',
        'value': true,
        'validators': [],
    }, {
        'field': 'toBeAddedBy',
        'type': 'boolean',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value ? 0: 1;
            },
            'setter': (data, value) => {
                switch(value) {
                    case 0:
                    case true:
                        return true;
                    case 1:
                    case false:
                        return false;
                }
                return false;
            }
        }
    }, {
        'field': 'status',
        'value': 0,
        'validators': [],
    }]
}

export const PartySignUpPresetOptionSchema = {
    'arrays': [{
        'array': 'shoppingForm',
        'schema': PartySignUpFormSchema,
        'value': [],
        'validators': []
    }],
    'fields': [{
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'imageUrls',
        'value': [],
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data, value) => value
        }
    }, {
        'field': 'imageUrlsFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageUrlsData',
        'value': [],
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const list = _.isString(data.imageUrls) ? _.split(data.imageUrls, ','): data.imageUrls;
                return _.isEmpty(list) ? []: list;
            }
        }
    }, {
        'field': 'thumbnailFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'thumbnailDataUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.thumbnailUrl === '' ? '/images/blank_1x1.png': data.thumbnailUrl
            }
        }
    }, {
        'field': 'name',
        'type': 'string',
        'value': '',
        'column': 0,
        'validators': [Validators.required, Validators.maxLength(128)]
    }, {
        'field': 'vImageUrls',
        'type': 'string',
        'value': [],
        'column': 1,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const list = _.isString(value) ? _.split(value, ','): value;
                return _.isEmpty(list) ? []: _.map(list, (element) => _.trim(element));
            }
        }
    }, {
        'field': 'thumbnailUrl',
        'type': 'string',
        'value': '/images/blank_1x1.png',
        'column': 2,
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_1x1.png': value
            }
        }
    }, {
        'field': 'minQuantity',
        'type': 'number',
        'value': 1,
        'column': 3,
        'validators': [Validators.required, Validators.min(1)],
        'options': {
            'getter': (control) => parseInt(control.value),
            'setter': (data, value) => {
                return value ? value: 0;
            },
            'validators': (data, value) => {
                const allowedQuantity = _.isNull(data.allowedQuantity) ? 0: data.allowedQuantity;
                return allowedQuantity > 0 ?
                    [Validators.required, Validators.min(1), Validators.max(allowedQuantity)]:
                    [Validators.required, Validators.min(1), Validators.max(1000)];
            }
        }
    }, {
        'field': 'allowedQuantity',
        'type': 'number',
        'value': 5,
        'column': 4,
        'validators': [Validators.required, Validators.min(1)],
        'options': {
            'getter': (control) => parseInt(control.value),
            'setter': (data, value) => {
                return value ? value: 0;
            },
            'validators': (data, value) => {
                const minQuantity = _.isNull(data.minQuantity) ? 0: data.minQuantity;
                return minQuantity > 0 ?
                    [Validators.required, Validators.min(minQuantity),Validators.max(1000)]:
                    [Validators.required, Validators.min(1), Validators.max(1000)];
            }
        }
    }, {
        'field': 'amount',
        'type': 'number',
        'value': 0,
        'column': 5,
        'validators': [Validators.required, Validators.min(0), Validators.max(400000)],
        'options': {
            'getter': (control) => parseFloat(control.value),
            'setter': (data, value) => {
                return value ? value: 0;
            },
            'validators': (data, value) => {
                const amount = value ? value: 0;
                return amount === 0 ?
                    [Validators.required, Validators.min(0), Validators.max(400000)]:
                    [Validators.required, Validators.min(1), Validators.max(400000)];
            }
        }
    }, {
        'field': 'valueProvided',
        'type': 'number',
        'value': 0,
        'column': 6,
        'validators': [Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => {
                return control.value;
            },
            'setter': (data, value) => {
                return value ? value: 0;
            }
        }
    }, {
        'field': 'enforceInventory',
        'type': 'boolean',
        'value': false,
        'column': 7,
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data, value) => value
        }
    }, {
        'field': 'inventory',
        'type': 'number',
        'value': 0,
        'column': 8,
        'validators': [],
        'options': {
            'getter': (control) => parseInt(control.value),
            'setter': (data, value) => value ? value: 0,
            'validators': (data, value) => {
                return data.enforceInventory ? [Validators.min(1)]: [Validators.min(0), Validators.max(0)];
            }
        }
    }, {
        'field': 'hideInventory',
        'type': 'boolean',
        'value': true,
        'column': 9,
        'validators': [],
        'options': {
            'getter': (control) => control.value,
            'setter': (data) => !data.enforceInventory ? true: data.hideInventory,
            'validators': (data) => {
                return data.enforceInventory ? []: [Validators.requiredTrue];
            }
        }
    }, {
        'field': 'sendTicket',
        'type': 'boolean',
        'value': true,
        'column': 10,
        'validators': []
    }, {
        'field': 'noQrCodeInEmail',
        'type': 'boolean',
        'value': false,
        'column': 11,
        'validators': []
    }, {
        'field': 'showTicketHolders',
        'type': 'boolean',
        'value': false,
        'column': 12,
        'validators': []
    }, {
        'field': 'optionStartDate',
        'type': 'datetime',
        'value': 0,
        'column': 13,
        'validators': [Validators.required, Validators.nullValidator]
    }, {
        'field': 'optionEndDate',
        'type': 'datetime',
        'value': 0,
        'column': 14,
        'validators': [Validators.required, Validators.nullValidator]
    }, {
        'field': 'hostName',
        'type': 'string',
        'value': '',
        'column': 15,
        'validators': [Validators.maxLength(128)]
    }, {
        'field': 'hostEmail',
        'type': 'string',
        'value': '',
        'column': 16,
        'validators': [Validators.pattern(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/), Validators.maxLength(128)]
    }, {
        'field': 'notifyHost',
        'type': 'boolean',
        'value': false,
        'column': 17,
        'validators': [],
        'options': {
            'validators': (data) => {
                if(data.hostName === "") {
                    return [requiredFalse];
                }
                if(data.hostEmail === "") {
                    return [requiredFalse];
                }
                return [];
            }
        }
    }, {
        'field': 'displayHostInfo',
        'type': 'boolean',
        'value': false,
        'column': 18,
        'validators': [],
        'options': {
            'validators': (data) => {
                if(data.hostName === "") {
                    return [requiredFalse];
                }
                if(data.hostEmail === "") {
                    return [requiredFalse];
                }
                return [];
            }
        }
    }, {
        'field': 'eventDetailLink',
        'type': 'string',
        'value': '',
        'column': 19,
        'validators': [(control: AbstractControl) => {
            if(control.value === "") {
                return null;
            }

            let url = true;
            try {
              const urlString = control.value.substr(0,4) === "www." ? `http://${control.value}`: control.value;
              new URL(urlString)
            } catch {
              url = false;
            }

            return url ? null : { url: true };
        }, Validators.maxLength(128)],
        'options': {
            'getter': (control) => control.value.substr(0,4) === "www." ? `http://${control.value}`: control.value
        }
    }, {
        'field': 'startDateTimeGmtUnix',
        'type': 'datetime',
        'value': 0,
        'column': 20,
        'validators': [Validators.required],
        'options': {
            'getter': (control) => _.isNull(control.value) ? 0: control.value,
            'setter': (data) => data.startDateTimeGmtUnix ? data.startDateTimeGmtUnix: 0
        }
    }, {
        'field': 'duration',
        'type': 'number',
        'value': 60,
        'column': 21,
        'validators': [Validators.required, Validators.min(1), Validators.max(1440)],
        'options': {
            'setter': (data, value) => {
                if(_.isNumber(value) && !_.isNaN(value)) {
                    return value < 1 ? 60: value;
                }
                return 60;
            }
        }
    }, {
        'field': 'vEventVenueName',
        'type': 'string',
        'value': '',
        'column': 22,
        'validators': [Validators.maxLength(128)],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'vEventVenueAddress',
        'type': 'string',
        'value': '',
        'column': 23,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'vEventVenueUnitNum',
        'type': 'string',
        'value': '',
        'column': 24,
        'validators': [Validators.maxLength(128)],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'desc',
        'type': 'string',
        'value': '',
        'column': 25,
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'summary',
        'type': 'string',
        'column': 26,
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'eventDates',
        'value': [],
        'validators': []
    }],
    'groups': [{
        'group': 'eventVenue',
        'fields': [{
            'field': 'formatted_address',
            'value': '',
            'validators': []
        }, {
            'field': 'name',
            'value': '',
            'validators': []
        }, {
            'field': 'address',
            'value': {},
            'validators': [],
            'options': {
                'getter': (control, form) => {
                    const { value: unitNum } = form.get('unitNum');
                    if(control.value instanceof Object) {
                        return { ...control.value, unitNum: unitNum };
                    }
                    return control.value;
                }
            }
        }, {
            'field': 'stringAddress',
            'value': "",
            'validators': []
        }, {
            'field': 'unitNum',
            'value': '',
            'validators': [],
            'options': {
                'virtual': true,
                'setter': (data, value) => {
                    const address = data ? data.address: null;
                    if(address instanceof Object) {
                        return data.address.unitNum;
                    }
                    return value;
                }
            }
        }]
    }, {
        'group': 'timeZoneData',
        'fields': [{
            'field': 'name',
            'value': () => moment.tz.guess(),
            'validators': [],
            'options': {
                'setter': (data, value) => _.isFunction(value) ? value(): value
            }
        }, {
            'field': 'abbr',
            'value': () => {
                const guess = moment.tz.guess();
                const zone = moment.tz.zone(guess);
                const timestamp = (new Date()).getTime();
                return zone.abbr(timestamp);
            },
            'validators': [],
            'options': {
                'setter': (data, value) => _.isFunction(value) ? value(): value
            }
        }, {
            'field': 'offset',
            'value': () => {
                const guess = moment.tz.guess();
                const zone = moment.tz.zone(guess);
                const timestamp = (new Date()).getTime();
                const abbr = zone.abbr(timestamp);
                const index = _.findIndex(zone.abbrs, (value) => _.isEqual(value, abbr));
                return zone.offsets[index] * -60;
            },
            'validators': [],
            'options': {
                'setter': (data, value) => _.isFunction(value) ? value(): value
            }
        }]
    }]
};

const clonedCampaignSchema = _.cloneDeep(CampaignSchema);
clonedCampaignSchema.fields.push({
    'field': 'type',
    'value': 5,
    'validators': [Validators.required]
})
clonedCampaignSchema.groups = [{
    'group': 'campaignTypeData',
    'arrays': [{
        'array': 'presetOptions',
        'schema': PartySignUpPresetOptionSchema,
        'value': [],
        'validators': []
    }],
    'fields': [{
        'field': 'endTime',
        'value': null,
        'validators': [],
        'options': {
            'getter': (control) => _.isNull(control.value) ? '': control.value,
        }
    }, {
        'field': 'gridView',
        'value': false,
        'validators': []
    }, {
        'field': 'multiSelect',
        'value': true,
        'validators': []
    },  {
        'field': 'postActivityFormUrlRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.postActivityFormUrl) ? false: true
        }
    }, {
        'field': 'postActivityFormUrl',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required, Validators.pattern(/^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$/i)]
        }
    }, {
        'field': 'sendTickets',
        'value': true,
        'validators': []
    }, {
        'field': 'startTime',
        'value': null,
        'validators': [],
        'options': {
            'getter': (control) => _.isNull(control.value) ? '': control.value,
        }
    }, {
        'field': 'addOnDonationCampaignRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.addOnDonationCampaignId) ? false: true
        }
    }, {
        'field': 'addOnDonationCampaignId',
        'value': null,
        'validators': [],
        'options': {
            'virtual': false,
            'getter': (control) => {
                return _.isEmpty(control.value) ? "": control.value;
            }
        }
    }],
    'groups': []
}];
export const PartySignUpSchema = clonedCampaignSchema;
